import React from 'react';
import topAds1 from '../../../../assets/images/doisotrung-520x70-02.gif';
import topAds2 from '../../../../assets/images/doisotrung-520x70-06.gif';

const BlockTop = () => {

    return <React.Fragment>
        <div className="modules_top">
            <div>
                <div id="hottoday">
                    <a href="/"><i className="btnprev"/></a>
                    <a href="/"><i className="btnnext"/></a>
                    <div>
                        <table style={{
                            width: "100%", border: "0", cellPadding: "3",
                            cellSpacing: "0"
                        }} className="border">
                            <tbody>
                            <tr>
                                <td><strong>Lịch Xổ Số 09/06/2021</strong>
                                </td>
                                <td colSpan="2" align="center"><strong>Thống
                                    kê tần suất xổ số</strong></td>
                                <td align="center"><strong>Gan cực
                                    đại</strong></td>
                                <td align="center"><strong>Thống kê
                                    Loto</strong></td>
                            </tr>
                            <tr>
                                <td><a className="hottoday_mien"
                                       href="/"
                                       title="Xổ Số Miền Nam"><strong>Xổ Số
                                    Miền Nam</strong></a></td>
                                <td className="norightborder"><a
                                    href="/"
                                    title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Miền Nam">Tần
                                    suất Miền Nam</a></td>
                                <td>
                                    <a href="/"
                                       title="Thống kê tần suất chi tiết xổ số Miền Nam"
                                       target="_blank">Chi tiết!.. </a></td>
                                <td>
                                    <a href="/"
                                       title="Thống kê Gan Cực Đại Xổ Số Miền Nam">GCĐ
                                        Miền Nam</a></td>
                                <td>
                                    <a href="/"
                                       title="Thống Kê lô các cặp số của Xổ Số Miền Nam">Xem
                                        Loto Miền Nam</a></td>
                            </tr>
                            <tr>
                                <td><a className="hottoday_tinh10"
                                       href="/"
                                       title="Xổ Số Đồng Nai"><span
                                    className="icon wait">Xổ Số Đồng Nai</span></a>
                                </td>
                                <td className="norightborder"><a
                                    href="/"
                                    title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Đồng Nai">Tần
                                    suất Đồng Nai </a></td>
                                <td>
                                    <a href="/"
                                       title="Thống kê tần suất chi tiết xổ số  Đồng Nai "
                                       target="_blank">Chi tiết!.. </a></td>
                                <td>
                                    <a href="/"
                                       title="Thống kê Gan Cực Đại Xổ Số Đồng Nai ">GCĐ
                                        Đồng Nai </a></td>
                                <td>
                                    <a href="/"
                                       title="/">Xem
                                        Loto Đồng Nai </a></td>
                            </tr>
                            <tr>
                                <td><a className="hottoday_tinh11"
                                       href="/"
                                       title="Xổ Số Cần Thơ"><span
                                    className="icon wait">Xổ Số Cần Thơ</span></a>
                                </td>
                                <td className="norightborder"><a
                                    href="/"
                                    title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Cần Thơ">Tần
                                    suất Cần Thơ </a></td>
                                <td>
                                    <a href="/"
                                       title="Thống kê tần suất chi tiết xổ số  Cần Thơ "
                                       target="_blank">Chi tiết!.. </a></td>
                                <td>
                                    <a href="/"
                                       title="Thống kê Gan Cực Đại Xổ Số Cần Thơ ">GCĐ
                                        Cần Thơ </a></td>
                                <td>
                                    <a href="/"
                                       title="Thống Kê lô các cặp số của Xổ Số Cần Thơ">Xem
                                        Loto Cần Thơ </a></td>
                            </tr>
                            <tr>
                                <td><a className="hottoday_tinh12"
                                       href="/"
                                       title="Xổ Số Sóc Trăng"><span
                                    className="icon wait">Xổ Số Sóc Trăng</span></a>
                                </td>
                                <td className="norightborder"><a
                                    href="/"
                                    title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Sóc Trăng">Tần
                                    suất Sóc Trăng </a></td>
                                <td>
                                    <a href="/"
                                       title="Thống kê tần suất chi tiết xổ số  Sóc Trăng "
                                       target="_blank">Chi tiết!.. </a></td>
                                <td>
                                    <a href="/"
                                       title="Thống kê Gan Cực Đại Xổ Số Sóc Trăng ">GCĐ
                                        Sóc Trăng </a></td>
                                <td>
                                    <a href="/"
                                       title="Thống Kê lô các cặp số của Xổ Số Sóc Trăng">Xem
                                        Loto Sóc Trăng </a></td>
                            </tr>
                            <tr>
                                <td><a className="hottoday_mien"
                                       href="/"
                                       title="Xổ Số Miền Bắc"><strong>Xổ Số
                                    Miền Bắc</strong></a></td>
                                <td className="norightborder"><a
                                    href="/"
                                    title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Miền Bắc">Tần
                                    suất Miền Bắc</a></td>
                                <td>
                                    <a href="/"
                                       title="Thống kê tần suất chi tiết xổ số Miền Bắc"
                                       target="_blank">Chi tiết!.. </a></td>
                                <td>
                                    <a href="/"
                                       title="Thống kê Gan Cực Đại Xổ Số Miền Bắc">GCĐ
                                        Miền Bắc</a></td>
                                <td>
                                    <a href="/"
                                       title="Thống Kê lô các cặp số của Xổ Số Miền Bắc">Xem
                                        Loto Miền Bắc</a></td>
                            </tr>
                            <tr>
                                <td><a className="hottoday_tinh48"
                                       href="/"
                                       title="Xổ Số Bắc Ninh"><span
                                    className="icon wait">Xổ Số Bắc Ninh</span></a>
                                </td>
                                <td className="norightborder"><a
                                    href="/"
                                    title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Bắc Ninh">Tần
                                    suất Bắc Ninh </a></td>
                                <td>
                                    <a href="/"
                                       title="Thống kê tần suất chi tiết xổ số  Bắc Ninh "
                                       target="_blank">Chi tiết!.. </a></td>
                                <td>
                                    <a href="/"
                                       title="Thống kê Gan Cực Đại Xổ Số Bắc Ninh ">GCĐ
                                        Bắc Ninh </a></td>
                                <td>
                                    <a href="/"
                                       title="Thống Kê lô các cặp số của Xổ Số Bắc Ninh">Xem
                                        Loto Bắc Ninh </a></td>
                            </tr>
                            <tr>
                                <td><a className="hottoday_mien"
                                       href="/"
                                       title="Xổ Số Miền Trung"><strong>Xổ
                                    Số Miền Trung</strong></a></td>
                                <td className="norightborder"><a
                                    href="/"
                                    title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Miền Trung">Tần
                                    suất Miền Trung</a></td>
                                <td>
                                    <a href="/"
                                       title="Thống kê tần suất chi tiết xổ số Miền Trung"
                                       target="_blank">Chi tiết!.. </a></td>
                                <td>
                                    <a href="/"
                                       title="Thống kê Gan Cực Đại Xổ Số Miền Trung">GCĐ
                                        Miền Trung</a></td>
                                <td>
                                    <a href="/"
                                       title="Thống Kê lô các cặp số của Xổ Số Miền Trung">Xem
                                        Loto Miền Trung</a></td>
                            </tr>
                            <tr>
                                <td><a className="hottoday_tinh30"
                                       href="/"
                                       title="Xổ Số Đà Nẵng"><span
                                    className="icon wait">Xổ Số Đà Nẵng</span></a>
                                </td>
                                <td className="norightborder"><a
                                    href="/"
                                    title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Đà Nẵng">Tần
                                    suất Đà Nẵng </a></td>
                                <td>
                                    <a href="/"
                                       title="Thống kê tần suất chi tiết xổ số  Đà Nẵng "
                                       target="_blank">Chi tiết!.. </a></td>
                                <td>
                                    <a href="/"
                                       title="Thống kê Gan Cực Đại Xổ Số Đà Nẵng ">GCĐ
                                        Đà Nẵng </a></td>
                                <td>
                                    <a href="/"
                                       title="Thống Kê lô các cặp số của Xổ Số Đà Nẵng">Xem
                                        Loto Đà Nẵng </a></td>
                            </tr>
                            <tr>
                                <td><a className="hottoday_tinh31"
                                       href="/"
                                       title="Xổ Số Khánh Hòa"><span
                                    className="icon wait">Xổ Số Khánh Hòa</span></a>
                                </td>
                                <td className="norightborder"><a
                                    href="/"
                                    title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Khánh Hòa">Tần
                                    suất Khánh Hòa </a></td>
                                <td>
                                    <a href="/"
                                       title="Thống kê tần suất chi tiết xổ số  Khánh Hòa "
                                       target="_blank">Chi tiết!.. </a></td>
                                <td>
                                    <a href="/"
                                       title="Thống kê Gan Cực Đại Xổ Số Khánh Hòa ">GCĐ
                                        Khánh Hòa </a></td>
                                <td>
                                    <a href="/"
                                       title="Thống Kê lô các cặp số của Xổ Số Khánh Hòa">Xem
                                        Loto Khánh Hòa </a></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="clear"/>
            </div>
            <div>
                <ul id="adv1"
                    style={{margin: '0 auto', padding: '0', width: '520px', height: '70px', overflow: "hidden"}}>
                    <li id="adv1_20989_0" style={{opacity: "1"}}><a
                        href="/">
                        <img src={topAds1} style={{display: 'none', border: "0", width: "520", height: "70"}} alt=""/>
                    </a>
                    </li>
                    <li id="adv1_20989_1" style={{opacity: '1'}}>
                        <a href="/">
                            <img src={topAds2} border="0" width="520" height="70" alt=""/>
                        </a>
                    </li>
                </ul>
                <div className="clear"/>
            </div>
        </div>

    </React.Fragment>;

}
export default BlockTop;
